import { EcrDefinitionsInfo } from "@/model/data/ecr/EcrDefinitionsInfo";

export class FitnessStatisticsState {

    availableEcrCodes: EcrDefinitionsInfo[] = [];
    availableSensorModels: string[] = [];
    availableSensorFirmwares: string[] = [];
    ecrFileVersion: string = null;
    ecrFileLastUpdate: Date = null;

}

export default new FitnessStatisticsState();